export const API_HOST = process.env.REACT_APP_API_HOST; //'sanasoftapi.mp73dev.reea.net/api/v1'
export const OAUTH_HOST = process.env.REACT_APP_OAUTH_HOST; //'sanasoftapi.mp73dev.reea.net';
export const API_PROTOCOL = process.env.REACT_APP_HOST_PROTOCOL;

export const API_PUBLIC_TOKEN_GRANT_TYPE = 'client_credentials';
export const API_REFRESH_TOKEN_GRANT_TYPE = 'refresh_token';
export const API_LOGIN_GRANT_TYPE = 'password';
export const API_PUBLIC_TOKEN_SCOPE = "*";
export const API_CLIENT_SECRET = process.env.REACT_APP_CLIENT_SECRET;
export const API_CLIENT_ID = process.env.REACT_APP_CLIENT_ID;